export default __webpack_public_path__ + "static/media/386.4f587db0.png";